import * as React from "react";
import { useState } from "react";
import { Button, Divider, Stack, Text, Box } from "@origin-digital/ods-core";
import AddressDialog from "./AddressDialog";
import { IFormProps } from "../FormAccordionContainer";
import { useFormikContext } from "formik";
import { FormValues } from "../types";
import { generateAddressString } from "../helper";
import FormContext from "src/context/FormContext";

interface AddressFieldProps extends IFormProps {
  isReadOnly: boolean;
}

const AddressField = (props: AddressFieldProps) => {
  const [dialogOpen, setDialog] = useState(false);
  const { setFieldValue, isReadOnly } = props;
  const { values, errors } = useFormikContext<FormValues>();
  const {
    formState: { address },
  } = React.useContext(FormContext);

  const addressString = generateAddressString(values.premiseAddress) || "";
  const hasAddress = !!addressString;
  const hasError = !!errors?.premiseAddressString;

  return isReadOnly ? (
    <Stack space="xsmall">
      <Box display="flex" alignItems="center">
        <Stack space="xxsmall">
          <Text id="address" variant="body-small" tone="neutralLight">
            Address
          </Text>
          <Text id="address-value" data-role="value" data-id="addressReadOnly">
            {address || "\u00A0"}
          </Text>
        </Stack>
      </Box>
      <Divider />
    </Stack>
  ) : (
    <>
      <Stack space="xsmall">
        <Box display="flex" alignItems="center">
          <Stack space="xxsmall">
            <Text
              id="address"
              variant="body-small"
              tone={hasError ? "critical" : "neutralLight"}
            >
              Address
            </Text>
            <Text id="address-value" data-id="address-value">
              {hasAddress ? addressString : "\u00A0"}
            </Text>
          </Stack>
          <Button
            variant="text"
            size="small"
            noTextPadding
            id="address-dialog-button"
            onClick={() => setDialog(true)}
          >
            {hasAddress ? "Update" : "Add"}
          </Button>
        </Box>
        <Divider />
        {hasError && (
          <Box display="flex">
            {/* <IconError color="critical" size="xsmall" /> */}
            <Box>
              <Text id="address-error" variant="body-small" tone="critical">
                {errors.premiseAddressString}
              </Text>
            </Box>
          </Box>
        )}
      </Stack>

      <AddressDialog
        open={dialogOpen}
        setDialog={setDialog}
        setFieldValue={setFieldValue}
      />
    </>
  );
};

export default AddressField;
